import currencySimpleUtility from '@/utils/currencySimple';
import numberFormat from '@/utils/numberFormat';
import currencyFull from '@/utils/currencyFull';
import { numberConstants, loyaltyConstants } from '@/utils/constants';

export default function loyaltyPointsFormat(
    value,
    loyaltyCurrency = loyaltyConstants.CURRENCY_TYPES.POINTS,
    currency,
    showCurrencyFullFormat = true
) {
    if (loyaltyCurrency === loyaltyConstants.CURRENCY_TYPES.MONEY) {
        return showCurrencyFullFormat
            ? currencyFull(value, currency)
            : currencySimpleUtility(value, currency);
    }

    return numberFormat(value, numberConstants.FORMAT.INTEGER);
}
